import { addDaysToDate, parseTaskDate, toCalendarISOString } from '@utils/dateOnlyParser';

export const WEATHER_PAST_DAYS = 90;
export const WEATHER_FUTURE_DAYS = 16;

/**
 * Bounds the weather query for the (potentially multi-year) Project view. The weather read
 * backfills every past date that has no stored row, so an unbounded 2-year range would fan out
 * hundreds of background writes on first read; forecasts do not extend past about a week anyway.
 * Returns null when nothing in the visible range falls inside `[today - 90d, today + 16d]`.
 * Inputs and outputs are inclusive YYYY-MM-DD strings.
 */
export function clampWeatherRange(
  from: string,
  to: string,
  today: Date = new Date(),
): { from: string; to: string } | null {
  const start = parseTaskDate(from);
  const end = parseTaskDate(to);
  if (!start || !end) return null;
  const todayDay = parseTaskDate(today)!;
  const floor = addDaysToDate(todayDay, -WEATHER_PAST_DAYS);
  const ceiling = addDaysToDate(todayDay, WEATHER_FUTURE_DAYS);
  const clampedStart = start < floor ? floor : start;
  const clampedEnd = end > ceiling ? ceiling : end;
  if (clampedStart > clampedEnd) return null;
  return { from: toCalendarISOString(clampedStart), to: toCalendarISOString(clampedEnd) };
}
